import React from "react";
import { useNavigate } from "react-router-dom";
import pageNotFoundImg from '../../assets/images/page-not-found.svg';
import { Button } from "antd";

const PageNotFound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <section className="pagenotfound__section">
      <div className="container">
        <h2>Oops!</h2>
        <div className="not_found_title">
          <span></span>
          <h1>Page not found</h1>
        </div>
        <figure>
          <img src={pageNotFoundImg} alt="page not found" width={562} height={357} />
        </figure>
        <div className="btn_wrapper">
          <Button type="primary" onClick={() => navigate(-1)}>Go Back</Button>
          <Button type="primary" onClick={() => navigate("/")}>Back to Home</Button>
        </div>
      </div>
    </section>
  );
};

export default PageNotFound;
